import NLFlag from '../_materiaal/flags/NL.svg'
import GBFlag from '../_materiaal/flags/GB.svg'
import DEFlag from '../_materiaal/flags/DE.svg'

export const languages = [
	{ label: 'NL', longLabel: 'Dutch', value: 'nl', svg: NLFlag },
	{ label: 'EN', longLabel: 'English', value: 'en', svg: GBFlag },
	{ label: 'DE', longLabel: 'Deutsch', value: 'de', svg: DEFlag },
]
